import type { FILTER_NAMES, FILTERS } from 'src/constants/reviews';
import { RATES_OPTIONS } from 'src/constants/reviews';

import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { TReviewsTags } from '../interfaces/reviews';

export enum QUERY_NAMES {
  BIRTHDATE = 'birthdate',
  ID = 'id',
  LOCATION = 'location',
  RATED = 'rated',
  REGION_ID = 'regionId',
  REVIEW_OBJECT_ID = 'reviewObjectId',
  TAG = 'tag',
  NAME = 'name',
  PHONE = 'phone',
  ORGANIZATION = 'organization',
  PRODUCT = 'product',
  TYPE = 'type',
  WIDGET_TYPE = 'widgetType',
  ORDER_BY = 'orderBy',
  FILTER = 'filterBy',
  ALIAS = 'alias',
  UID = 'uid',
  IS_CLIENT = 'isClient',
  SPECIFIC_PRODUCT = 'specificProduct',
  SQUEEZE_IDS = 'squeezesVectorIds',
}

export enum UTM_QUERIES_NAMES {
  SOURCE = 'utm_source',
  CAMPAIGN = 'utm_campaign',
  MEDIUM = 'utm_medium',
}

export type ALL_ROUTER_QUERIES = {
  [QUERY_NAMES.BIRTHDATE]?: string;
  [QUERY_NAMES.ID]?: number;
  [QUERY_NAMES.LOCATION]?: string;
  [QUERY_NAMES.RATED]?: RATES_OPTIONS | RATES_OPTIONS[];
  [QUERY_NAMES.REGION_ID]?: string;
  [QUERY_NAMES.REVIEW_OBJECT_ID]?: string;
  [QUERY_NAMES.TAG]?: TReviewsTags;
  [QUERY_NAMES.NAME]?: string;
  [QUERY_NAMES.PHONE]?: string;
  [QUERY_NAMES.ORGANIZATION]?: string;
  [QUERY_NAMES.PRODUCT]?: string;
  [QUERY_NAMES.TYPE]?: PAGE_TYPE;
  [QUERY_NAMES.WIDGET_TYPE]?: 'reviewsRating' | 'reviewsListDefault' | 'reviewsListXl';
  [QUERY_NAMES.ORDER_BY]?: FILTERS[FILTER_NAMES.ORDER];
  [QUERY_NAMES.FILTER]?: FILTERS[FILTER_NAMES.FILTER];
  [QUERY_NAMES.ALIAS]?: string;
  [QUERY_NAMES.UID]?: string;
  [QUERY_NAMES.IS_CLIENT]?: string;
  [QUERY_NAMES.SPECIFIC_PRODUCT]?: string;
  [QUERY_NAMES.SQUEEZE_IDS]?: string;
};

export type UTM_QUERIES = {
  [UTM_QUERIES_NAMES.SOURCE]?: string;
  [UTM_QUERIES_NAMES.CAMPAIGN]?: string;
  [UTM_QUERIES_NAMES.MEDIUM]?: string;
};

export type TReviewPageQuery = Pick<
  ALL_ROUTER_QUERIES,
  QUERY_NAMES.TYPE | QUERY_NAMES.ORGANIZATION | QUERY_NAMES.ID | QUERY_NAMES.TAG
>;

export type TReviewListQuery = Pick<
  ALL_ROUTER_QUERIES,
  | QUERY_NAMES.TYPE
  | QUERY_NAMES.ORGANIZATION
  | QUERY_NAMES.REVIEW_OBJECT_ID
  | QUERY_NAMES.TAG
  | QUERY_NAMES.LOCATION
  | QUERY_NAMES.RATED
  | QUERY_NAMES.REGION_ID
  | QUERY_NAMES.PRODUCT
  | QUERY_NAMES.IS_CLIENT
  | QUERY_NAMES.SPECIFIC_PRODUCT
  | QUERY_NAMES.SQUEEZE_IDS
>;

export type TCreateReviewPageQuery = UTM_QUERIES &
  Pick<
    ALL_ROUTER_QUERIES,
    | QUERY_NAMES.TYPE
    | QUERY_NAMES.ORGANIZATION
    | QUERY_NAMES.ID
    | QUERY_NAMES.REVIEW_OBJECT_ID
    | QUERY_NAMES.REGION_ID
    | QUERY_NAMES.TAG
    | QUERY_NAMES.BIRTHDATE
    | QUERY_NAMES.NAME
    | QUERY_NAMES.PHONE
    | QUERY_NAMES.SPECIFIC_PRODUCT
    | QUERY_NAMES.PRODUCT
  > & {
    scrollToExtraInfo?: 'true';
  };
